// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_vDc","cls2":"CreateSocialItem-cls2_WXP CreateSocialItem-cls1_vDc"};